// extracted by mini-css-extract-plugin
module.exports = {"redirectLanding":"styles_redirectLanding__PHtHN","continueButton":"styles_continueButton__Yju5H"};